import { getListBrowserStore } from '@ts-private/list-browser';

export const leasingServiceTypesStore = getListBrowserStore({
  filterDefinitions: [
    {
      name: 'code',
      caption: 'LeasingServiceType.Code',
      type: 'text'
    },
    {
      name: 'name',
      caption: 'LeasingServiceType.Name',
      type: 'text'
    },
    {
      name: 'categoryId',
      caption: 'LeasingServiceType.Category',
      type: 'select',
      underlyingType: 'number'
    }
  ],
  orderByFields: [
    {
      caption: 'LeasingServiceType.Name',
      value: 'ServiceName'
    },
    {
      caption: 'LeasingServiceType.Code',
      value: 'ServiceCode'
    }
  ],
  pager: {
    orderBy: 'ServiceName',
    direction: 'asc'
  }
});
